import uiConfigurationsBusinessGeneralDuplicateDeal from './general-config/duplicate-deal/index.vue' 

export {
    uiConfigurationsBusinessGeneralDuplicateDeal
}